import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './CustomSingleSelectEditableRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.editable
    ? _c(
        "InlineEdit",
        {
          attrs: {
            value: _vm.value,
            confirm: _vm.confirm,
            placement: _vm.placement
          },
          on: { "save-requested": _vm.onSaveRequested },
          scopedSlots: _vm._u(
            [
              {
                key: "editor",
                fn: function(props) {
                  return _c("Select", {
                    attrs: {
                      value: props.value,
                      options: _vm.options,
                      normalizer: _vm.normalizer,
                      "open-on-focus": true,
                      "is-invalid": props.isInvalid,
                      "is-focused": props.isFocused,
                      "is-loading": props.isLoading,
                      placeholder: _vm.placeholder,
                      "append-to-body": _vm.appendToBody
                    },
                    on: {
                      input: props.input,
                      blur: props.blur,
                      confirm: props.confirm,
                      focus: props.focus,
                      cancel: props.cancel
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "selected",
                          fn: function(ref) {
                            var selected = ref.selected;
                            return _vm._t("selected", null, {
                              selected: selected
                            })
                          }
                        },
                        {
                          key: "option",
                          fn: function(ref) {
                            var option = ref.option;
                            return _vm._t("option", null, { option: option })
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                }
              }
            ],
            null,
            false,
            2394714089
          )
        },
        [_vm._v(" "), _vm._t("default")],
        2
      )
    : _c("div", { staticClass: "slot" }, [_vm._t("default")], 2)
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/CustomSingleSelectEditableRenderer.vue.js